/* eslint-disable camelcase */
import React from 'react';

import sidbar_title from '../../images/sidbar_title.png';
import sidebar_phone from '../../images/sidebar_phone.png';
import ReservationForm from './ReservationForm';

const SideBar = ({ style = { container: {} } }) => (
  <div
    style={{
      width: '251px',
      border: '1px solid #e5e5e5',
      ...style.container,
    }}
  >
    <img
      src={sidbar_title}
      style={{ width: '100%' }}
      alt={`Customer Center ${process.env.REACT_APP_HP} ${process.env.REACT_APP_EMAIL} ${process.env.REACT_APP_TITLE}`}
    />
    <img
      src={sidebar_phone}
      style={{ width: '100%' }}
      alt={`Customer Center ${process.env.REACT_APP_HP} ${process.env.REACT_APP_EMAIL} ${process.env.REACT_APP_TITLE}`}
    />
    <ReservationForm visibleAlert={false} oneLinePolicy />
  </div>
);

SideBar.propTypes = {};

export default SideBar;
